export default __webpack_public_path__ + "static/media/sheep_decoy.eac54071.png";